export default "__VITE_ASSET__VI9tKDZG__"